// extracted by mini-css-extract-plugin
export default {"cls1":"x4H1txBi3cHDCzNb0btC","cls2":"FBRton7KKd_S8mBRqDTW x4H1txBi3cHDCzNb0btC"};